import { useEffect, useState } from "react";
import { api } from "./api";

const cache = {};
const load = (key, url) => {
  cache[key] = cache[key] || api.get(url).then((r) => r.data).catch(() => null);
  return cache[key];
};
export const clearSiteContent = (key) => { delete cache[key]; };

const useCached = (key, url, fallback) => {
  const [v, setV] = useState(fallback);
  useEffect(() => { let on = true; load(key, url).then((d) => on && d && setV(d)); return () => { on = false; }; }, [key, url]);
  return v;
};

export const DEFAULT_EMAILS = { contact: "hello@critterposts.ca", payment: "payment@critterposts.ca" };
export const useSiteEmails = () => useCached("emails", "/site/emails", DEFAULT_EMAILS);
export const useSafetyNotes = () => useCached("safety", "/site/safety-notes", null);
export const useInfoPage = (slug) => useCached(`page_${slug}`, `/site/pages/${slug}`, null);
export const useHomeFeed = () => useCached("home_feed", "/site/home-feed", { fresh_mode: "button", fresh_step: 4, browse_mode: "pages", similar_row: true, recent_row: true });
export const pick = (bi, lang) => (bi?.[lang] || bi?.en || "");
